import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'coordsString'
})
export class CoordsStringPipe implements PipeTransform {
  transform(value: any): string {
    if (!value) {
      return '';
    }

    if (typeof value === 'string') {
      return value;
    }

    if (Array.isArray(value[0])) {
      console.warn('[CoordsStringPipe][transform] La geometria risultava complessa, copiato il primo punto');
      return value[0].join(',');
    }

    if (Array.isArray(value)) {
      return value.join(',');
    }

    try {
      return JSON.stringify(value);
    } catch (error) {
      console.warn('[CoordsStringPipe][transform]', error, value);
      return '';
    }
  }
}
